var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 109,
    viewBox: "0 0 232 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_2959_994",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.687023 31.9254C19.637 16.6814 43.7808 6.3002 70.0652 2.09441C96.3497 -2.11138 123.594 0.0471757 148.354 8.29712C173.113 16.5471 194.275 30.5179 209.164 48.4428C224.053 66.3678 232 87.4418 232 109L96.5 109L0.687023 31.9254Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.687023 31.9254C19.637 16.6814 43.7808 6.3002 70.0652 2.09441C96.3497 -2.11138 123.594 0.0471757 148.354 8.29712C173.113 16.5471 194.275 30.5179 209.164 48.4428C224.053 66.3678 232 87.4418 232 109L96.5 109L0.687023 31.9254Z",
    stroke: "#2051A3",
    strokeWidth: 2,
    strokeDasharray: "7 7",
    mask: "url(#path-1-inside-1_2959_994)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/line.319fa00614168c3f4b56a2bc8c91563f.svg";
export { ForwardRef as ReactComponent };